const ENDPOINT_BASE='/requests/';

export const getRequestUrl = (id) => {
    return ENDPOINT_BASE+id;
}

export const getSentRequestsUrl = () => {
    return ENDPOINT_BASE+'all/sent';
}

export const getReceivedRequestsUrl = () => {
    return ENDPOINT_BASE+'all/received';
}

export const getOpenRequestsUrl = () => {
    return ENDPOINT_BASE+'all/open';
}

export const getCreateRequestUrl = () => {
    return ENDPOINT_BASE;
}

export const getDeclineRequestUrl = (id) => {
    return ENDPOINT_BASE+id+'/decline';
}

export const getCompleteRequestUrl = (id) => {
    return ENDPOINT_BASE+id+'/complete';
}

export const getCancelRequestUrl = (id) => {
    return ENDPOINT_BASE+id;
}